export default __webpack_public_path__ + "static/media/TRUCK8.5f196a47.jpg";